export default function DataTable() {
    return (
    <div>
        <table>
            <thead>
            <tr>
                <th>Subdomain</th>
                <th>Favorites</th>
                <th>Worked before</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>Data Manipulation and Analysis</td>
                <td>pandas, polars</td>
                <td>Alteryx, KNIME</td>
            </tr>
            <tr>
                <td>Machine Learning</td>
                <td>PyTorch, scikit-learn</td>
                <td>Tensorflow, LangChain</td>
            </tr>
            <tr>
                <td>Data Visualization</td>
                <td>QuickSight, plotly</td>
                <td>PowerBI, Tableau, Looker</td>
            </tr>
            </tbody>
        </table>
    </div>
    )
}